import { Component, OnInit } from '@angular/core';
import { ColumnDef, flexRenderComponent } from '@tanstack/angular-table';
import {
  TableHeadSelectionComponent,
  TableRowSelectionComponent,
} from '../../components/select-column/select-column';
import { Table } from '../../components/table/table';
import { AdminService } from '../../services/admin-service';
import { Button } from '../../components/button/button';
import { Modal } from '../../components/modal/modal';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '../../components/input/input';
import { ToastService } from '../../services/toast-service';
import { TableButtons } from '../../components/table-buttons/table-buttons';
import { ConfirmDialogService } from '../../services/confirm-dialog-service';
import { ConfirmDialog } from '../../components/confirm-dialog/confirm-dialog';
import { Loading } from '../../components/loading/loading';

export interface TClient {
  clientId: string;
  clientLabel: string;
  users: User[];
  merchants: any;
}

export interface User {
  id: number;
  userId: string;
  clientId: string;
  clientLabel: string;
  merchantId: string;
}

@Component({
  selector: 'app-clients',
  imports: [Table, Button, Modal, ReactiveFormsModule, InputComponent, ConfirmDialog, Loading],
  templateUrl: './clients.html',
  styleUrl: './clients.scss',
})
export class Clients implements OnInit {
  loading = false;

  showModal = false;
  showConfirmDialog = false;
  message = '';

  data: any[] = [];

  constructor(
    private confirmDialogService: ConfirmDialogService,
    private adminService: AdminService,
    private toast: ToastService
  ) {
    this.confirmDialogService.showDialog$.subscribe(({ message }) => {
      this.message = message;
      this.showConfirmDialog = true;
    });
  }

  columns: ColumnDef<TClient>[] = [
    {
      id: 'select-col',
      header: () => flexRenderComponent(TableHeadSelectionComponent),
      cell: () => flexRenderComponent(TableRowSelectionComponent),
    },
    {
      accessorKey: 'clientLabel',
      header: 'Client Label',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'clientId',
      header: 'Client ID',
      cell: (info) => `<i>${info.getValue<string>()}</i>`,
    },
    {
      accessorKey: 'merchants',
      header: 'Estabelecimentos',
      cell: (info) => {
        const merchants = info.getValue() as Array<any>;

        return `<a class="text-primary" href="/admin/estabelecimentos/${info.row.original.clientLabel}/${info.row.original.clientId}">( ${merchants.length} )<a/>`;
      },
    },
    {
      accessorKey: 'users',
      header: 'Usuários',
      cell: (info) => {
        const users = info.getValue() as Array<any>;

        return `<a class="text-primary" href="/admin/users/${info.row.original.clientLabel}/${info.row.original.clientId}">( ${users.length} )</a>`;
      },
    },
    {
      id: 'actions',
      enableHiding: false,
      cell: ({ row }) => {
        const client = row.original;
        return flexRenderComponent(TableButtons, {
          inputs: {
            title: 'trash',
          },
          outputs: {
            clickEvent: () => this.deletarCliente(client),
          },
        });
      },
    },
  ];

  clientRegister = new FormGroup({
    label: new FormControl('', [Validators.required, Validators.minLength(3)]),
  });

  ngOnInit(): void {
    this.getClients();
  }

  getClients() {
    this.loading = true;
    this.adminService.getClients().subscribe({
      next: (resp) => {
        this.data = resp;
      },
    });

    this.loading = false;
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  salvar() {
    if (this.clientRegister.invalid)
      this.toast.show({
        message: 'Error',
        type: 'warn',
      });

    this.adminService.registerClient(this.clientRegister.value.label!).subscribe({
      next: () => {
        this.toast.show({
          type: 'success',
          message: 'Cliente Adicionado',
        });
        this.getClients();
        this.closeModal();
      },
    });
  }

  onConfirm() {
    this.confirmDialogService.confirm();
    this.showConfirmDialog = false;
  }

  onCancel() {
    this.confirmDialogService.cancel();
    this.showConfirmDialog = false;
  }

  deletarCliente(client: TClient) {
    this.confirmDialogService
      .requestConfirmation(`Deseja deletar [${client.clientLabel}]?`)
      .subscribe((confirmed) => {
        if (confirmed) {
          this.adminService.deleteClient(client.clientId).subscribe(() => {
            this.toast.show({
              message: 'Cliente deletado com sucesso',
              type: 'info',
            });

            this.getClients();
          });
        } else {
          console.log('Ação cancelada');
        }
      });
  }
}
